import React from 'react';
import { FormattedMessage } from 'react-intl';

// Hooks
import { useModal } from '../../../../hooks';
import usePlanSummary from '../hooks/usePlanSummary';

// Styles
import { StyledDd, StyledDl, StyledDt } from '../plansummary.styled';

// Components
import { GIButton } from 'app-components';
import { enrollmentStatusMap } from '../planSummary.constants';

const PaymentLink = ({ plan }) => {
    const { openModal } = useModal();
    const { isPaymentLinkHidden, payForPlan } = usePlanSummary();

    const shouldShow =
        plan.disEnroll &&
        plan.paymentUrl &&
        plan.enrollmentStatus &&
        plan.enrollmentStatus.toUpperCase() === enrollmentStatusMap.PENDING.toUpperCase() &&
        !isPaymentLinkHidden &&
        Number(plan.netPremium) !== 0;

    if (!shouldShow) {
        return null;
    }

    const onPayNowClick = () => {
        payForPlan(
            {
                caseNumber: plan.caseNumber,
                typeOfPlan: plan.typeOfPlan,
                enrollmentId: plan.enrollmentId,
            },
            openModal,
        );
    };

    return (
        <>
            <StyledDl>
                <StyledDt as="dt" data-testid="payment-url-label">
                    <FormattedMessage id="plansummary.paymenturl" />:
                </StyledDt>
                <StyledDd as="dd">
                    <GIButton
                        id="pay-health-insurance_btn"
                        data-testid="pay-health-insurance-button"
                        labelId="plansummary.payForHealthPlan"
                        onClickHandler={onPayNowClick}
                    />
                </StyledDd>
            </StyledDl>
        </>
    );
};

export default PaymentLink;
